import { isEmpty } from 'lodash-es';
import { useCallback, useRef } from 'react';

import { horizontalScrollTo } from '../../../utils/scrollPage';

function useTableAutoScroll() {
  const scrollableContainerRef = useRef();
  const memoCoordsRef = useRef({});

  const handleChartZoomChange = useCallback(({ columnKey }) => {
    if (isEmpty(memoCoordsRef.current)) {
      scrollableContainerRef.current.querySelectorAll('[data-key]').forEach((el) => {
        memoCoordsRef.current[el.dataset.key] = el.getBoundingClientRect();
      });
    }

    if (memoCoordsRef.current[columnKey]) {
      const { left, width } = scrollableContainerRef.current.getBoundingClientRect();
      const offsetLeft = left + width;
      const leftCoord = memoCoordsRef.current[columnKey].right - offsetLeft;

      horizontalScrollTo({
        destination: leftCoord > 0 ? leftCoord : 0,
        scrollableArea: scrollableContainerRef.current,
      });
    }
  }, []);

  return [scrollableContainerRef, handleChartZoomChange];
}

export default useTableAutoScroll;
